import {NgModule} from '@angular/core';
import {SaleRetrocessionConverter} from './api/entity/converter/saleRetrocession.converter';
import {SaleRetrocessionSummaryConverter} from './api/entity/converter/saleRetrocessionSummary.converter';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {SaleRetrocessionRepository} from './impl/service/ngrx/sale-retrocession.repository';
import {SaleRetrocessionDataService} from './impl/service/ngrx/sale-retrocession-data.service';
import {
    SaleRetrocessionSummaryDataServiceAdapter
} from './impl/service/ngrx/sale-retrocession-summary-data.service.adapter';
import {SaleRetrocessionDataServiceAdapter} from './impl/service/ngrx/sale-retrocession.service.adapter';

@NgModule({
    providers: [
        SaleRetrocessionConverter,
        SaleRetrocessionSummaryConverter,
        SaleRetrocessionRepository,
        SaleRetrocessionDataService,
        SaleRetrocessionDataServiceAdapter,
        SaleRetrocessionSummaryDataServiceAdapter
    ],
})
export class SaleRetrocessionModule {
     constructor(
         entityDataService: EntityDataService,
         entityServices: EntityServices,
         service: SaleRetrocessionRepository,
         dataService: SaleRetrocessionDataService,
    ) {

        entityDataService.registerServices({
            SaleRetrocession: dataService,
        });

        entityServices.registerEntityCollectionServices({
            SaleRetrocession: service,
        });

        //  errorMessages.set('PRODUCT_SAVE_CODE_ALREADY_USED', 'Un produit avec ce code existe déjà');
    }
}
